import { TForeignTradeByRegionsState } from './types';

export function getRegionAggregated(state: TForeignTradeByRegionsState) {
  return state.regionAggregated;
}
